module.exports = __webpack_public_path__ + "img/ftth_index03.f4a4d30d.jpg";